module.exports = __webpack_public_path__ + "static/media/activities-icon.485c144f.svg";